import { transparent } from "material-ui/styles/colors"

const THEME_PRIMARY = "#01ACDB"

export const colors = {
  // Marketplaces colors
  autouncle: "#1298CC",
  mobile: "#FF5E24",
  autoscout24: "#F6F142",
  "automobile.it": "#BD4B00",
  subito: "#F9423A",

  // Black
  black: "#000",
  // White
  white: "#FFF",
  // Transparent
  transparent: transparent,

  gradient_blue: "#D1F1FA",
  gradient_red: "#FAD1D1",
  gradient_green: "#D1FAD1",

  // Gray
  gray_50: "#FAFAFA",
  gray_100: "#F5F5F5",
  gray_200: "#EEEEEE",
  gray_300: "#E0E0E0",
  gray_400: "#BDBDBD",
  gray_500: "#9E9E9E",
  gray_600: "#757575",
  gray_700: "#616161",
  gray_800: "#424242",
  gray_900: "#212121",

  // Blue
  blue_50: "#EBF9FD",
  blue_100: "#ABE2F0",
  blue_200: "#74cde6",
  blue_300: "#35BBDC",
  blue_400: THEME_PRIMARY,
  blue_450: "#2B4F7C",
  blue_500: "#1298CC",
  blue_600: "#0C7FB5",
  blue_700: "#00649D",
  blue_800: "#0D4672",
  blue_900: "#00477F",
  blue_1000: "#02234C",

  // Green Link Color
  green_300: "#50D19B",

  //Variant
  variant_50: "#F8FDFF",
  variant_100: "#EDF5F9",
  variant_200: "#DCEAF4",
  variant_300: "#BFD0E0",
  variant_400: "#9DAEC1",
  variant_500: "#738398",
  variant_600: "#546682",
  variant_700: "#394B6D",
  variant_800: "#243458",
  variant_900: "#162348",

  info: THEME_PRIMARY,
  error: "#F01010",
  success: "#66BB6A",
  warning: "#FFA726",

  // Price Rating
  super: "#026214", // rgb(2, 98, 20)
  good: "#68A52E", // rgb(104, 165, 46)
  fair: "#069B66", // rgb(6, 155, 102)
  overpriced: "#E39806", // rgb(227, 152, 6)
  expensive: "#AD1D19", // rgb(173, 29, 25)

  blue_grey_50: "#F8FAFC",
  blue_grey_100: "#ECF1F8",
  blue_grey_200: "#DAE4F1",
  blue_grey_300: "#C9D9E8",
  blue_grey_400: "#8597AD",
  blue_grey_500: "#6A89AF",
  blue_grey_600: "#3E4B5C",

  green_200: "#CCFAD1",
  green_600: "#51B283",
  red_50: "#E74B4B",
  orange_200: "#FEF08A",
  orange_300: "#FDE047",
  orange_600: "#CA8A04",
}

// Make sure to update PaddingType when making changes to spacing array
export const spacing = [
  "0px", // 0
  "4px", // 1
  "8px", // 2
  "12px", // 3
  "16px", // 4
  "24px", // 5
  "32px", // 6
  "40px", // 7
  "48px", // 8
  "64px", // 9
  "80px", // 10
]

export type PaddingType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10

export const width = {
  "1/10": "10%",
  "1/5": "20%",
  "1/4": "25%",
  "3/10": "30%",
  "1/3": "33%",
  "2/5": "40%",
  "1/2": "50%",
  "3/5": "60%",
  "2/3": "66%",
  "7/10": "70%",
  "3/4": "75%",
  "4/5": "80%",
  "9/10": "90%",
  full: "100%",
  inherit: "inherit",
  auto: "auto",
  maxContent: "max-content",
  content: "950px",
}

export const radius = {
  full: "30px",
  large: "16px",
  medium: "8px",
  small: "4px",
  sharp: "0px",
}

export const justify = {
  start: "flex-start",
  end: "flex-end",
  center: "center",
  between: "space-between",
  around: "space-around",
  evenly: "space-evenly",
}

export const align = {
  start: "flex-start",
  end: "flex-end",
  center: "center",
  baseline: "baseline",
  stretch: "stretch",
}

export const content = {
  start: "flex-start",
  end: "flex-end",
  center: "center",
  between: "space-between",
  around: "space-around",
  evenly: "space-evenly",
}

const shadows = {
  shadow_base:
    "0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1);",
  shadow_50: "0px 4px 24px rgba(2, 35, 76, 0.08);",
  shadow_100: "0px 8px 40px rgba(2, 35, 76, 0.16);",
}

const fonts = {
  fontDisplay: "Manrope",
  fontBody: "Inter",
  fontSerif: "Lora",
}

export const theme = {
  ...colors,
  ...shadows,
  ...fonts,
  spacing,
  width,
  align,
  justify,
  content,
  radius,
}
